// src/dashboard/pages/teacher/Palmares/components/PalmaresDataTable.jsx

import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

import {
  formatDateFr,
  formatEventLabel,
  getAdherentFromPalmares,
  getAvatarSrc,
  getMemberDisplayName,
  getResolvedEventFromPalmares,
} from "../utils/palmaresDashboardUtils";

import VisibilitySwitch from "./VisibilitySwitch";

export default function PalmaresDataTable({
  items = [],
  events = [],
  onEdit,
  onDelete,
  onToggleIsActive,
  deletingId,
  togglingId,
}) {
  return (
    <div className="hidden md:block">
      <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900/60">
        <table className="min-w-[1080px] w-full">
          <thead className="sticky top-0 z-20">
            <tr className="bg-slate-50 text-xs uppercase tracking-wide text-slate-600 dark:bg-slate-900 dark:text-slate-300">
              <th className="w-28 px-4 py-3 text-left font-bold">Accueil</th>
              <th className="px-4 py-3 text-left font-bold">Adhérent</th>
              <th className="px-4 py-3 text-left font-bold">Palmarès</th>
              <th className="px-4 py-3 text-left font-bold">Événement lié</th>
              <th className="px-4 py-3 text-left font-bold">Date</th>
              <th className="sticky right-0 z-30 w-32 bg-slate-50 px-4 py-3 text-right font-bold dark:bg-slate-900">
                Actions
              </th>
            </tr>
          </thead>

          <tbody className="divide-y divide-slate-100 text-sm dark:divide-slate-800">
            {items.map((item) => {
              const adherent = getAdherentFromPalmares(item);
              const event = getResolvedEventFromPalmares(item, events);

              return (
                <tr
                  key={item.id}
                  className="transition hover:bg-slate-50/80 dark:hover:bg-slate-800/40"
                >
                  <td className="px-4 py-3">
                    <VisibilitySwitch
                      checked={!!item.is_active}
                      disabled={togglingId === item.id}
                      onChange={() => onToggleIsActive(item.id)}
                    />
                  </td>

                  <td className="px-4 py-3">
                    <div className="flex items-center gap-3">
                      <img
                        src={getAvatarSrc(adherent?.photo_url)}
                        alt={getMemberDisplayName(adherent)}
                        className="h-12 w-12 rounded-2xl object-cover ring-1 ring-slate-200 dark:ring-slate-700"
                        onError={(event) => {
                          event.currentTarget.src = "/img/user_avatar.jpg";
                        }}
                      />

                      <div className="min-w-0">
                        <div className="font-bold text-slate-900 dark:text-white">
                          {getMemberDisplayName(adherent)}
                        </div>
                      </div>
                    </div>
                  </td>

                  <td className="px-4 py-3">
                    <div className="font-bold text-slate-900 dark:text-white">
                      {item.titre_palmares || "—"}
                    </div>

                    <div className="mt-2 flex flex-wrap gap-2">
                      {item.resultats_palmares ? (
                        <span className="inline-flex rounded-full bg-sky-50 px-2.5 py-1 text-xs font-bold text-sky-700 ring-1 ring-sky-200 dark:bg-sky-500/10 dark:text-sky-300 dark:ring-sky-500/20">
                          Résultat : {item.resultats_palmares}
                        </span>
                      ) : null}

                      {item.classement_palmares ? (
                        <span className="inline-flex rounded-full bg-amber-50 px-2.5 py-1 text-xs font-bold text-amber-700 ring-1 ring-amber-200 dark:bg-amber-500/10 dark:text-amber-300 dark:ring-amber-500/20">
                          Classement : {item.classement_palmares}
                        </span>
                      ) : null}
                    </div>

                    {item.observations_palmares ? (
                      <p className="mt-2 max-w-[420px] text-sm leading-6 text-slate-600 dark:text-slate-300">
                        {item.observations_palmares}
                      </p>
                    ) : null}
                  </td>

                  <td className="px-4 py-3">
                    <p className="max-w-[280px] text-sm leading-6 text-slate-600 dark:text-slate-300">
                      {item.event_palmares_id ? formatEventLabel(event) : "—"}
                    </p>
                  </td>

                  <td className="px-4 py-3 font-bold text-slate-800 dark:text-slate-100">
                    {formatDateFr(item.date_palmares)}
                  </td>

                  <td className="sticky right-0 z-10 bg-white px-4 py-3 dark:bg-slate-900">
                    <div className="flex items-center justify-end gap-2">
                      <button
                        type="button"
                        onClick={() => onEdit(item)}
                        className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-50 hover:text-indigo-700 dark:border-slate-700 dark:bg-slate-800 dark:text-slate-200 dark:hover:bg-slate-700"
                        title="Modifier"
                      >
                        <FaEdit />
                      </button>

                      <button
                        type="button"
                        onClick={() => onDelete(item)}
                        disabled={deletingId === item.id}
                        className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-rose-200 bg-rose-50 text-rose-700 transition hover:bg-rose-100 disabled:opacity-50 dark:border-rose-500/20 dark:bg-rose-500/10 dark:text-rose-300"
                        title="Supprimer"
                      >
                        <FaTrash />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
